export default {
    view: 'template',
    borderless: true,
    autoheight: true,
};
